<template>
  <sticky-header-layout>
    <template #header>
      <list-page-header>
        <el-pagination
          slot="left"
          :disabled="isLoading"
          :current-page="listQuery.page"
          :page-sizes="listQuery.sizes"
          :page-size="listQuery.size"
          :total="listQuery.total"
          background
          layout="total, sizes, pager, jumper"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
        <div
          slot="right"
          class="button-container"
        >
          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleClickCreateButton"
          >{{ $t('button.create') }}</el-button>

          <el-button
            class="add-button"
            type="primary"
            icon="el-icon-edit"
            @click="handleClickUploadButton"
          >{{ $t('button.uploadMultiple') }}</el-button>
        </div>
      </list-page-header>
    </template>

    <custom-table
      :loading="isLoading"
      :data="list"
      :column-list="columnList"
    >
      <template #columns="{ row, type }">
        <!-- List of Tags -->
        <template v-if="isList(row[type])">
          <template v-if="type === 'available_countries' && isAllCountriesSelected(row[type])">
            All
          </template>
          <template v-else-if="row[type].length > 0">
            <el-tag
              v-for="(item, index) in row[type]"
              :key="index"
            >{{ item }}</el-tag>
          </template>
          <template v-else>
            /
          </template>
        </template>
        <!-- List of Tags -->

        <template v-else-if="type === 'SEO'">
          <a
            :href="`/seo/edit/type/3/key/${row.slug}`"
            class="seo-link"
            target="_blank"
          >
            <font-awesome-icon icon="external-link-alt" />
          </a>
        </template>
      </template>

      <action-column
        slot="action-column"
        is-edit
        is-delete
        @edit="handleEditButtonClick"
        @delete="handleDeleteButtonClick"
      />
    </custom-table>
  </sticky-header-layout>
</template>

<script>
import { createComponent, onBeforeMount } from '@vue/composition-api'

import ActionColumn from '../../../components/table/ActionColumn.vue'
import CustomTable from '../../../components/table/CustomTable.vue'
import ListPageHeader from '../../layout/components/ListPageHeader.vue'

import useTablePaging from '../../../hooks/useTablePaging'
import TrendingFeedsService from '../../../api/trending-feeds'
import { feedColumnList } from '../../../const/trending/feed'
import { countryList } from '../../../utils/form'

const TrendingFeedList = createComponent({
  name: 'TrendingFeedList',
  components: {
    ActionColumn,
    CustomTable,
    ListPageHeader,
  },
  setup(_, { root }) {
    const { $router, $confirm } = root

    const listHandler = (newList) => {
      newList.forEach((item) => {
        item.available_countries = Object.keys(item.available_countries).reduce((acc, key) => {
          if (item.available_countries[key] === 1) {
            acc.push(key)
          }
          return acc
        }, [])
      })
      return newList
    }
    const {
      isLoading,
      list,
      listQuery,
      getList,
      handleSizeChange,
      handlePageChange,
    } = useTablePaging({
      service: TrendingFeedsService.getList,
      listHandler,
    })

    onBeforeMount(() => {
      getList()
    })

    const deleteFeed = async (id) => {
      await TrendingFeedsService.delete(id)
      handlePageChange(1)
      getList()
    }

    const handleClickCreateButton = () => {
      $router.push({ path: '/trending-feeds/create' })
    }
    const handleClickUploadButton = () => {
      $router.push({ path: '/trending-feeds/upload' })
    }
    const handleEditButtonClick = ({ id }) => {
      $router.push({ path: `/trending-feeds/edit/${id}` })
    }
    const handleDeleteButtonClick = ({ id }) => {
      $confirm(root.$t('message.confirmToDelete'), root.$t('common.warning'), {
        confirmButtonText: root.$t('button.delete'),
        cancelButtonText: root.$t('button.cancel'),
        confirmButtonClass: 'el-button--danger',
        type: 'warning',
      }).then(() => {
        deleteFeed(id)
      })
    }

    const isList = data => Array.isArray(data)
    const isAllCountriesSelected = data => data.length === countryList.length

    return {
      isLoading,
      list,

      columnList: feedColumnList,

      listQuery,
      handleSizeChange,
      handlePageChange,

      handleClickCreateButton,
      handleClickUploadButton,
      handleEditButtonClick,
      handleDeleteButtonClick,

      isList,
      isAllCountriesSelected,
    }
  },
})

export default TrendingFeedList
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";
@import "~@/assets/styles/table.scss";

::v-deep {
  .el-tag {
    white-space: normal;
    height: auto;
    word-break: break-word;
  }
}
</style>
